export const environment = {
  production: false,
  API: "https://api-backend.dev.koortimativa.com.br/api/v1",
  AWS_LAMBDA: "https://fbftss2vwj.execute-api.us-east-1.amazonaws.com",
};